export default __webpack_public_path__ + "static/media/back_jump_hover.4261f1cb.svg";